import { createFileRoute } from "@tanstack/react-router";
import { StravaCallbackPage } from "@/modules/collect-data/presentation/pages/StravaCallbackPage";

export const Route = createFileRoute("/_authenticated/strava/callback")({
  validateSearch: (search: Record<string, unknown>) => ({
    code: typeof search.code === "string" ? search.code : undefined,
    error: typeof search.error === "string" ? search.error : undefined,
  }),
  component: function StravaCallbackRoute() {
    const { code, error } = Route.useSearch();
    return <StravaCallbackPage code={code} error={error} />;
  },
});
